module.exports = __webpack_public_path__ + "img/spinner.df498d35.gif";